var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMenuMausseite = function SvgMenuMausseite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      isolation: "isolate"
    },
    viewBox: "20 20 54 52"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#menu_mausseite_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#629533",
    d: "M67.528 58.867c-1.86 8-33.72 10.22-42 4s-5.91-31.35-1.62-37.62 22.24-5.17 22.49-5.17a35.2 35.2 0 0 1 17.06 3.15c8.59 4.07 5.92 27.66 4.07 35.64"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#669B35",
    d: "M43.488 20.357h.58a10 10 0 0 0 5.27-.24h.58c1.33.77 2.88-.38 4.2.46.29 2.27-1.29 2.07-2.33 2 2.26-1.08 3.54 2.71 6.11 1.84.222-.152.465-.273.72-.36 1.82.14 1 1.69 1.4 2.6a6.3 6.3 0 0 1-.4 1.49c-.21 1.36 0 3.2-2.38 1.82-1.3-.76-1.48.68-2.14 1.18-1.94.45-1.81-2.32-3.51-2.25-.72-.62 1.67-1.16-.06-2-1.2-.62-1.51 0-2 .6-.68.77.82.83.53 1.51a1.16 1.16 0 0 1-.38.75 4.1 4.1 0 0 1-2.63.12c-1.23-.21-2.79.44-3.43-1.31.08-1.1.94-.61 1.47-.8-.47.3-1.55-1-1.51.67.1 1 .87 2.17-.63 2.81-.92.11-1-.66-1.26-1.21-.47-.15.07-1.55-1.09-.86a3.64 3.64 0 0 1-1.88.17 2.1 2.1 0 0 1-.71-.34 1 1 0 0 1-.15-.74c.83-.95 1.14-2.38 2.58-2.77a11.8 11.8 0 0 1 2.84-.06c1.86.17 3.45 0 3.86-2.13a3.9 3.9 0 0 0-2.22.11l-.57.12c0 .2.18.06.25 0 .52 0 1 0 1 .71-1.49 1.68-3 1.71-4.51 0a3.72 3.72 0 0 1 2.4-3.89"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#629433",
    d: "m68.788 35.617.42 9.34a2.48 2.48 0 0 1-2.06.71 7.1 7.1 0 0 0-2.15-.12c-2.51 1.64-5.13.66-7.72.35-1.21-1.28.17-1.34.82-1.59.815-.232 1.648-.4 2.49-.5 1.3-.3.64-1.05.49-1.71.1-1.21-.68-1.32-1.59-1.26-2.76-.53-2.71-.49-1.12-2.55.93-1.2 3-1.66 2.44-3.93-.12-.52 1.11-.92 1.87-1.11.267-.037.539-.02.8.05 1.42 1.59 3.65 1.29 5.31 2.32"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#679C36",
    d: "m43.488 20.357-2.18 3.6c-.56.82-1.55 1-2.51 1.73.67-.32 1.07-.28 1.42.08-1 .57-.5 2.53-2.23 2.44-.64.9-1.27 1.81-2.61 1.27a7 7 0 0 1-.76-.23c-2-1-3.77.47-5.67.57-.71-.05-1.41-.12-1.62-1 2.33-2.38 5.19-3 8.46-2.49-1.08-.81-2-1.88-3.48-1.36-.85.3-1.73 1.31-2.62.25s-.33-2.18.38-3.18a2.08 2.08 0 0 1 2.76-.08c.77-1 2.12-.6 3.06-1.21z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5D8D30",
    d: "m66.868 45.077 2.34-.12.06 1.17-.61.6c-1.4 2-4 3.17-4.42 5.9-.44 1.27-1.27 1.34-2.31.73-1.42-.84-2.76-1.89-4.56-1.73q-1.352.49-2.75.83a1.72 1.72 0 0 1-1.317-.507 1.72 1.72 0 0 1-.493-1.323c0-1.33 1.14-1.05 1.91-1.18 1.34-.21 2.34-1.37 3.76-1.32.57.06 1 .53 1.57.55.4 0 .89-.11.87-.5 0-.71-.7-.31-1.09-.4a23.3 23.3 0 0 0-8.52.36c-1.57 0-3.16.12-4.37-1.17.08-1.29 1.15-1.6 2.06-2.07 1.88.47 3.86-.19 5.73.44.72.18 1.5-.25 2.2.19 1.52 0 3-.38 4.54.24s2.4-.83 3.62-1.2c.256.596.322 1.256.19 1.89 0 .2-.29.36-.08.6q.112-.378.31-.72a2.19 2.19 0 0 1 1.36-1.26"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#639633",
    d: "M66.618 27.517c1.39 1.44.92 3.63 2.06 5.17v.59c-1.69 1.39-3.51 0-5.26.24h-.59c-.87-1.09-1.69-2.28-3.4-1.84-1.67-.23-1.89.49-1.16 1.81-1.29 1.56-2.41.69-3.53-.23a1.8 1.8 0 0 1-.38-.67c-.09-.7.64-1 .74-1.65.45-2.63 1-2.79 3.67-1.06.59-.61-.73-1.5.29-2a11.8 11.8 0 0 0 2.27-.42c1.75.35 3.52-.65 5.29.06"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#659A35",
    d: "M63.418 33.517c1.68-1.73 3.53.43 5.26-.24l.11 2.34c-2.27.52-4.17.17-5.37-2.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#649734",
    d: "M30.068 22.067c.4 1-.72 2 .16 3.27 1.7-1.94 3.62-1.05 5.55-.5.81.23 1.53.48 1.26 1.51-.2.79-.87 1.77-1.55 1.31-3.07-2.07-5.37.71-8 1.05-.13 1.49 2.89 2.18.84 4.09 1.14.4 2.3-.54 3.11.54a1.17 1.17 0 0 1-.61 1.48 2.9 2.9 0 0 1-1.71.27c-1.21-.53-2.38-.1-3.68.22 1-.08 1.84-.63 2.76-.42.85 2.77.72 3-2 2.66a4.8 4.8 0 0 0-2 .29c-.34.11-.83-.15-1 .39a5 5 0 0 1-.08.66c.06.37-1.21 1.11.3 1.07a2.16 2.16 0 0 1-.3 1.91c-.72 1.4-1.13 3.07-2.95 3.56-.27-3.35-.027-6.722.72-10 1-.41-.32-1.33.39-1.8.77-7.15 3.18-10.31 8.79-11.56"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#629533",
    d: "M54.878 64.867c-3.62 1.1-7.37 1-11.1 1.07-.65-.27-1.44-.18-1.43-1.39 0-2.29-1.33-3.57-3.61-3.84a1.15 1.15 0 0 1-.69-.39c.24-2.72.48-2.87 3.51-1.79-1.2-.35-1.9-.89-2.78-.87-.41-.78-.67-1.55.17-2.24 2.74.24 5.4-1.35 8.17-.38.232.172.404.414.49.69a2.3 2.3 0 0 1-1.14 1.66 2 2 0 0 1-1.27.24s-.31-.51-.28.08c0 .37 0-.14.2.21.51.7 1.39.87 2 1.41.63.86-.17 1.73 0 2.59.2.39.56.67.78 1 .057.19.057.391 0 .58a9.3 9.3 0 0 0 3.56-.32 5.7 5.7 0 0 1 .9-.09c1.09.3 2.88-.5 2.52 1.78"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#649735",
    d: "M34.308 65.337c-7.83-.38-11.99-3.89-13.22-11.14a9.4 9.4 0 0 1 5.75.06 1.58 1.58 0 0 1 .44 1.7c-.25.83-1.16.42-1.61.8 1.44.63 3.34-.11 4.46 1.52-.63 1.24-1.29 2.44-2.52 2.3 2-.3 4.77-1.23 5.87 2.28.33.73 1.15.91 1.67 1.42.34.33.7.71.2 1.14a.91.91 0 0 1-1.04-.08"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#649735",
    d: "M38.868 60.407c.62-.86 1.68-.78 1.88-.06.48 1.75 4.22 2 2.2 4.87q.395.383.83.72c-2.331.32-4.7.228-7-.27-.62-.55-.23-1.2-.19-1.82 0-1.59-1.5-1.5-2.4-2-1.23-.7-2.48-1.33-3.67-2.1a1.8 1.8 0 0 1 1.67-2.6 2.9 2.9 0 0 0 2.29-1.33 2.23 2.23 0 0 1 1.94.27c.72.56 1.68.72 2.32 1.39l3.82.58c-.75 2.25-4.75-1.71-4.27 2.37-.367.431-.988.54-1.48.26-.4-.26-.71-.65-1.19-.94.26.35.62.46.87.71.447.371.993.604 1.57.67.38.06.59.79 1 .28.07-.06-.38-.59-.19-1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#629533",
    d: "M51.908 63.957h-.58c-.3-.25-.78-.34-.81-.85.26-1.32 1.42-1.53 2.4-2 .4-.31 1 .06 1.36-.48a3 3 0 0 1-.46-.28 4.9 4.9 0 0 0-2.58-1.93 1 1 0 0 1-.4-.54c-.95-1-3.36.6-3.39-2 1-1.5 2.58-1.38 4.06-1.57a2.84 2.84 0 0 1 2.46.43c1.22 1.96 3.65 1.22 5.21 2.35q.368.183.67.46c.122.243.14.524.05.78-.89 1.07-1.28 1.89.64 2.3 1.07.23 2.59-.13 3 1.52a2.18 2.18 0 0 1-1.67.74c-2.43.31-4.81 1.08-7.31.28a2.6 2.6 0 0 0-2.65.79"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5D8D30",
    d: "m20.208 47.187-.06-1.16a1.33 1.33 0 0 1 1-.42 6.7 6.7 0 0 0 2.57-.26c1.67 0 3.37-.34 4.94.51a2 2 0 0 0 2.15-.15 2.44 2.44 0 0 1 2.36.61c.37.45.71.91.35 1.53a9.9 9.9 0 0 1-6.42.27c2.39 1.12 2.39 1.12.36 3.71-2.68 2.65-4.76 2.87-6.64.7-1.12-3.57 2.07-2.36 3.69-3.22-1.53-.75-3.41-.51-4.3-2.12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#639534",
    d: "M67.928 53.407c-.34 2.71.06 5.68-2.64 7.57-.61.36-1 0-1.34-.42 0-1.2-1.1-1.2-1.77-1.66-.11-1.71-1.87-.2-2.35-1.2-.35-.83.41-1.16.74-1.68.94-1.6 2.5-1 3.87-1.12.34-.11.69.36.94.08s-.14-.51-.28-.77c-.45-1-.35-1.8.83-2 .88-.11 2.07-.44 2 1.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#609232",
    d: "m21.218 45.957-1.07.05v-.6c.92-1.18 1.26-2.8 2.66-3.62l.33.22c.47.48.7 1.16 1.53 1.64-.06-.79-.69-1.36-.47-2a4.06 4.06 0 0 1 4.69-1.17c.295.288.535.627.71 1 .19.503.19 1.058 0 1.56-.111.218-.29.394-.51.5-.63.17-.48.52-.2.91.095.474.125.959.09 1.44l-.15.34-5.29-.35c-.78-.35-1.53.22-2.32.08"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#629433",
    d: "M63.688 52.247c.29-1.72 3.49-5.27 5-5.51a11.3 11.3 0 0 1-.42 4.73c-1.26 1.97-3.14.06-4.58.78"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#669A35",
    d: "m59.828 57.697 3.25-.68-.86 1.74c-.14.35-.62.5-.53 1 .58.21 1.18.08 1.74.27.239.101.453.251.63.44l1.23.55a2.46 2.46 0 0 1-1.76 1.17c-1-.29-1.95-.61-2.93-.88s-2.13.36-2.43-1.26 1.1-1.6 1.66-2.35"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#659935",
    d: "M63.688 52.247c.6-.4.93-1.64 2-.69.88.79 1.72.49 2.55-.09a2.27 2.27 0 0 1-.31 1.94 1.85 1.85 0 0 0-2.55-.45l.75 1.49c-.4.69-1.23.25-1.73.67-.11.55-.26 1.39-1 .72-1.29-1.24-1.77 0-2.48.61a.812.812 0 0 1-1.17-.46c-.36-.86.35-1.18.88-1.57s1.38 0 2.3-.2c-1 .09-1.27-.31-1.22-1 .07-.12.15-.23.22-.34.8.32 1.69.9 1.76-.63"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#679B37",
    d: "M51.908 63.957a1.778 1.778 0 0 1 2.25-1.58c2.55 1.33 5.23-.62 7.7.55a16.74 16.74 0 0 1-7 2c-.5-1.83-1.92-.8-2.95-.97"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#629533",
    d: "M20.208 47.187c1.27 0 2.12 1.38 3.76.75 1.24-.48.72 1.69 2 2-1.83 1-4.9-1.21-5 2.53a.43.43 0 0 1-.1.73c-.9-1.94-.6-3.99-.66-6.01"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#629533",
    d: "M20.888 53.167c0-.24.07-.49.1-.73 2.44 2 4.32.07 6.34-.88l.38.12c.75.53 1.6 1 1.62 2.06a1.1 1.1 0 0 1-.62.44c-.64-.09-1.17.48-1.83.33-1.93-.1-3.91.65-5.79-.31z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#679B35",
    d: "m37.268 63.957-.5 1.67a3.2 3.2 0 0 1-2.46-.33c.78-.16 1.13-.37.15-.87-.71-.36-1.87-.17-1.92-1.43 1.89-1.2 3.43-.69 4.73.96"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6B9E3C",
    d: "M21.238 33.657c-.11 1.24 1.28.39 1.57 1.11-.42.94-1.29.52-2 .69a2 2 0 0 1 .43-1.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#629433",
    d: "m29.218 41.517-.6-.56a.998.998 0 0 0 .37-1.67 2.43 2.43 0 0 1 2.41-1.45c.21 0 .52.24.6-.2-.3-.56-1.07-.92-.66-1.73a4.1 4.1 0 0 1 1.75-1c.86-.24 1.68-.55 2.54-.75a24 24 0 0 1 2.77-.27c1.69-.05 3.37-.2 5.06-.15 1.81.75 4-.44 5.72 1.09.47.41 1.05-.23 1-.89s-.48-1.24-.61-1.89a1.8 1.8 0 0 1 .06-.8c.58-.66 1.43-1.12 1.61-2.1a4 4 0 0 1 .22-.32c2.32-1.13 2.34 1.55 3.61 2.17.93.9.2 1.05-.53 1.2-.4.3-.89.54-.73 1.17.63.88 2.27.78 2.23 2.31-.46.95-.49 2.07-1.08 3a2 2 0 0 1-2-.18c-.51-.27-1-.84-1.59-.54-1.75 1-3.83.64-5.75 1-1.77 1.4-5.54 1.39-7.34.11-.94-.66.08-1.74-.69-2.35-.21-.12-.43-.4-.67-.26s0 .44 0 .67c.39 1.17 1.47 2.25.42 3.58-1.21.95-2.71.08-4 .62-.79.36-1.624.612-2.48.75a2.3 2.3 0 0 1-1.64-.56"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#659935",
    d: "M66.618 27.517c-1.9.64-3.8 1.23-5.77.26-.7-.06-.92-.64-1.23-1.12-.92-.48.31-2.17-1.27-2.28l-.06 1.13c-1.37-1-3.74.31-4.48-1.93-.42-1.25-1.21-.68-1.77-.43-2 .89-1.91-.5-2.33-1.86 1.68 0 3.26 2 4.43-.26 4.81.85 9.93 1.18 12.48 6.49"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#629533",
    d: "m38.278 34.657-2.92.13a2.58 2.58 0 0 1-.15-1.83c.195-.164.423-.284.67-.35a2.07 2.07 0 0 0 1.52-1 2.5 2.5 0 0 1 .69-.42c1.37-.21 2.72-.71 4.12-.25 1.86-.47.84-1.94 1-3a.36.36 0 0 1 .58 0c.7 2.09 2.38.67 3.57 1 .77 1.16 0 1.82-.79 2.44a2 2 0 0 1-1.07.24c.83.15 1.53-.49 2.26 0 .38.28.57.6.29 1.06-2.22 2-5.07.22-7.44 1.27-.81.01-1.74-.21-2.33.71"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#649734",
    d: "M35.088 28.957c1.16.55 1.93-.5 2.9-.72v.58c.13.67-.49 1.11-.51 1.72.08.41.39.81.06 1.23-1.2 1.08-2.8.06-4.06.8a4.2 4.2 0 0 1-.86.14c-3.56.21-3.56.2-3.39-3.49 1.93-.41 3.81-2.08 5.84-.26-.18.62-.8.74-1.42 1.18.7-.38 1.29-.54 1.44-1.18"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#629533",
    d: "m40.218 25.787-1.36-.27c.33-1.3 1.33-1.51 2.45-1.54q2.18 2.54 4.09-.19c-.2-.18-.55-.21-.61-.56 1.09-2 2.31-.17 3.57-.07-1.63.42-.82 3.63-3.1 2.85-1.76-.59-3.41.58-5.04-.22"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#699F37",
    d: "M49.728 28.867c0-.72-1.66-.28-1.08-1.14s.6-2.13 1.91-2.38c.74-.14 1 .2 1.14.88.28 1 1.47 1.05 2.19 1.66-.78.48-1.87 0-2.4.9a1.26 1.26 0 0 1-1.76.08"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5F9031",
    d: "M46.328 31.357c.3-.82 1.2-1.37 1.07-2.39a3.86 3.86 0 0 0 2.36.48 1.23 1.23 0 0 1 .08 1.75v.59c.37.41.4.93 0 1.18a1.32 1.32 0 0 1-1.69-.52l-.61-.56c-.32-.38-.92-.13-1.21-.53"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5F9131",
    d: "M36.928 30.617c-.28-1 .76-1.18 1.09-1.81h.58a1.85 1.85 0 0 0 2.34-.11c1-.31.82.74 1.22 1.12-1.48 1.9-3.35 1.43-5.23.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#679C36",
    d: "M36.928 30.617c1.75-.22 3.61.23 5.23-.82.67.36.09.77.05 1.17-1.42 1-3.08.63-4.64.79z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6CA13A",
    d: "M43.828 27.957h-.86a2.6 2.6 0 0 1-.35-.33c1.46-.46 3-1.35 4.37.4-1.12.84-2.14.33-3.16-.07"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#649834",
    d: "m49.838 31.197-.08-1.75v-.58l1.76-.08c1.1 1.95-.08 2.32-1.68 2.41"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#679C36",
    d: "m44.788 23.227.61.56c-.85-.09-1.51 1-2.47.44-.02-1.57.81-1.5 1.86-1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6A9F38",
    d: "M59.618 26.657a2 2 0 0 1 1.23 1.12c-.54 1.2-1.12 1.23-1.76.08z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#649734",
    d: "M40.938 28.677c-.74.86-1.49 1.57-2.34.11zM55.898 35.617c-.35-1.64-2.82-.37-3-2.21.51-.4 1.27-.13 1.73-.66 1.2 0 2.13 2.14 3.53.42-.27-1-.28-1.81 1.09-1.81 2.37-1.2 3.56-.46 3.61 2.18-2.42 1.54-2.42 1.54.39 3.14-2.47.48-4.38 1.3-5.38 3.54l1.75-.08c.65.51 1.67.62 1.83 1.67-.32 1.42 1.84.12 1.54 1.35s-1.52 1-2.31 1.42c-1.15.64-2.72-.25-3.74.95a4 4 0 0 1-2.32.69c-.38-.39-.52-1-.14-1.27 2.66-1.94.59-2.79-.82-3.8a5.6 5.6 0 0 1-1.04-.92 1.51 1.51 0 0 1 0-1.55c.125-.24.311-.444.54-.59l1.78.5a2.4 2.4 0 0 1 1-.57c2.01-.76 1.33-1.58-.04-2.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#669A35",
    d: "M66.248 36.867c.76.39 1.74.23 1.63 1.42-.09 1-.65 1.71-1.61 1.67-1.38-.05.2-1.62-1-2.18-.41-.21.64-.61.98-.91"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#679C36",
    d: "M61.448 41.807a3.7 3.7 0 0 1-1.83-1.67c2.43-.05 2.46-.01 1.83 1.67"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#58852E",
    d: "M66.868 45.077a2 2 0 0 1-1.11 1.22.348.348 0 0 1-.58 0 1.52 1.52 0 0 1-.08-1.75z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5B8B2F",
    d: "M63.498 40.297c.5.13.94.42 1 .93s-.5.44-.85.44-.82-.13-.83-.6a.75.75 0 0 1 .68-.77"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#609232",
    d: "M29.248 29.207c.1.17.16.42.31.49 1.57.69-1.29 2.34.5 2.72 1.06.22 2.27-.29 3.41-.47.73.5 2.27-.81 2.39 1.06h-.58a2.3 2.3 0 0 1-.79.58 3.39 3.39 0 0 1-3.3-.39c-.74.19-1.49.37-2.23.57a1.66 1.66 0 0 1-1.28-.28c1.22-1.87-.05-3.14-1-4.49l.78-.32c.46.69 1.16.54 1.79.53M47.018 46.557a8.8 8.8 0 0 0 4.15 1c.51.54.29 1-.15 1.45-1.87.87-3.75 1.26-5.65.07-1.21-.92-1.8.15-2.5.81s-.28 1.63-.84 2.3a2 2 0 0 1-1.79-.36c-.48-.33-1-.64-1.54-.17a2.1 2.1 0 0 1-.67.26 4.5 4.5 0 0 1-1.84-.1 5.7 5.7 0 0 1 .24-4.47c.44-.82-1.23-1.16-.67-2.13a10 10 0 0 1 1.72-1.26c1.69-.94 3.38-2.29 5 .06a1.8 1.8 0 0 1 0 .83c-.31.7-1.11.65-1.6 1.07-.3.35-.29.74.11.93.09 0-.16-.57.11-.83 1.33-1.19 3.26-.29 4.63-1.33a1.35 1.35 0 0 1 1.44.64 1.1 1.1 0 0 1-.15 1.23"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#629433",
    d: "M50.618 48.737c.395-.257.603-.723.53-1.19 3.06-1.38 6.21-.76 9.35-.43.1 1.32-.86 1.21-1.7 1.25-1.83.51-3.05 2.78-5.6 1.57.17 1.33.52 2 1.67 2.12 1-.56 1.45-.14 1.44.93-.212.406-.6.69-1.05.77a14 14 0 0 0-3.69.34c-.87.12-1.68.49-2.54.65-1.36.24-2-.52-2-1.82-.07-.8-.44-1.62.07-2.41.97-1.03 2.94-.03 3.52-1.78"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#619332",
    d: "M52.618 39.867q1.376.736 2.67 1.61c1.35 1 3.85 2.08.06 3.26-.57.18-.68.88-.69 1.48-.65-.1-1.21-1.23-1.75-.64-1.42 1.55-2.39-.13-3.56-.29-.58-.41-1.28.17-1.87-.21-.68-.65-1.68-.7-2.39-1.3-.18-1.06.79-1.26 1.33-1.79.325-.25.731-.371 1.14-.34 2 1.22 2 1.22 5.1.52.18.12.3.33.53.4-.25-.15-.46-.34-.71-.52-.7-.38-1.42-.79-1.18-1.73.13-.69.65-.84 1.32-.45"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#639734",
    d: "m58.818 48.367 1.7-1.25c.56-.13 1.33-1 1.61.09a1.91 1.91 0 0 1-1.33 2.27c-1.18.48-1.85.21-1.98-1.11"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5F9131",
    d: "M56.108 53.177a1.07 1.07 0 0 0-1.22-1.12l2.29-1.27c.63.82 1.68 1 2.46 1.53a.89.89 0 0 1 .09.76c-1.12.72-2.1 2.05-3.67.87a.65.65 0 0 1 .05-.77"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#639634",
    d: "M59.618 52.437c-1.25.09-2.52.23-2.42-1.65a5.65 5.65 0 0 1 4.76 2.17 2 2 0 0 1-2.34-.52"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#629433",
    d: "M65.178 46.317h.58a3 3 0 0 0 0 .28c0 .89-.1 1.7-1.11 2-.37.11-.85.08-.89-.38-.09-1.02.73-1.43 1.42-1.9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#639634",
    d: "M47.528 44.777c.64 0 1.33-.16 1.78.51-.8.36-1.26 1.31-2.29 1.27v-1.17c-.23-.54-.05-.74.51-.61"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#609232",
    d: "m59.218 31.357-1.09 1.81c-.64-.09-1.82.28-1.43-.91.33-.98 1.17-2.04 2.52-.9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#689D36",
    d: "M54.618 32.747c0 .33.22.88.09 1-.66.47-1.21-.16-1.82-.32-.16-1.4.28-2 1.7-1.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#619332",
    d: "m28.898 34.497 1.72-.08c.44.91-.37 1.72-.19 2.61-.19 1.71-2.15 1.49-2.87 2.64a3.64 3.64 0 0 1-2.44.12 8.4 8.4 0 0 1-2.5-1.49v-.58a.772.772 0 0 1 1.16-.06c1.18-1.77 2.5-1.42 3.9.06l.67-2.61c.01-.36.39-.38.55-.61"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#659934",
    d: "m25.018 39.357 2.93-.13a.78.78 0 0 1 1.16-.05l2.23 1c-.83 1.08-1.87.59-2.73.79a7.86 7.86 0 0 0-4.07.77 1.25 1.25 0 0 1-1.75.08l.51-1.78c.32-.85.85-1.22 1.72-.68M30.178 36.787c-1.27-1.08.47-1.55.48-2.37.393-.259.6-.724.53-1.19l3.51-.16c.3 1.39-1.17 1.56-1.65 2.41l-1.73.67c-.24.46-.48.92-1.14.64"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5C8C2F",
    d: "m25.018 39.357-1.72.67c-2.54.31-.19-1.25-.67-1.73a2.06 2.06 0 0 1 2.39 1.06"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#679D35",
    d: "m28.898 34.497-.56.61c-1.22-.22-2.22 1.08-3.62.5 1.19-1.41 2.78-.9 4.18-1.11"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#689D36",
    d: "m23.768 37.657-1.15.06c-.34-.21-.65-.6-.28-.83.79-.51 1.07.27 1.43.77"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#689E36",
    d: "M47.898 52.957c-.41 1.55.41 1.69 1.45 1.09a4.1 4.1 0 0 1 2.09-.67c.65.41 1.29.83.66 1.73a12.1 12.1 0 0 0-4.65.8c-1.3-1-2.85-.67-4.08-.23a8.07 8.07 0 0 1-4.72.05.5.5 0 0 1-.68 0c0-1.15 1.33-1.13 1.63-2 .94-2.22 2.68-.25 4-.75 1.41.12 2.86-1.02 4.3-.02"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#609232",
    d: "M47.448 55.957c.91 1.52 2.19 1 3.54.81 1-.12 1.3.42 0 .78-.07.2-.58.42 0 .59 1.78-.32 2.8.41 3 2.2-1.15.88-2.45.1-3.65.34a2.29 2.29 0 0 0-2.48 1.19 1.94 1.94 0 0 1-1.39.57c-1.31-1.21.93-1.87.45-2.95a1.87 1.87 0 0 1-.66-1.24 3.8 3.8 0 0 1 0-1.07 2 2 0 0 1 1.19-1.22"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#679B37",
    d: "M49.978 59.897a11 11 0 0 1 4.11.4c.55.19 1.33-.82 1.63.18.2.66-.46.91-1.07.95l-1.67.09c-2-.49-2.34 1.24-3.21 2.28a3 3 0 0 1-2-.28v-.59c.028-.384.167-.752.4-1.06a4 4 0 0 1 1.81-1.97"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#609132",
    d: "m36.528 60.507 1.75-.08h.59q.709.494 1.35 1.07c.44.44.66 1 .11 1.51s-.86.2-1.26-.18c-.83-.78-1.69-1.53-2.54-2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5D8E30",
    d: "M38.068 55.757h.58a1.5 1.5 0 0 1 .08 1.74c-.92-.06-2.13.5-2.39-1.06.36-.81.85-1.26 1.73-.68"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#669B35",
    d: "m46.938 57.697.08 1.75c-1.25.11-2.26-.13-2.41-1.64a2.27 2.27 0 0 1 2.33-.11"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#699F37",
    d: "m47.788 63.517 2.35-.11c.18-.24.37-.26.58 0l.61.56c-1.57.74-3.15.17-4.74.09.23-.69.79-.45 1.2-.54"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5E8F31",
    d: "m48.328 62.317-.56.61a1.22 1.22 0 0 1-1.2-.53 1.23 1.23 0 0 1 1.15-.64c.52-.16.81-.06.61.56"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5B8A2F",
    d: "m46.938 57.697-2.32.11c.21-1.17 1.18-.36 1.72-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#679C35",
    d: "m38.068 55.757-1.73.66-1.78-.46a10 10 0 0 1-7.6.34l-.08-1.75c.23-1.13.84-1.27 1.73-.67 1.75-.07 3.46-.55 5.22-.45a17 17 0 0 1 3.88 0 5.55 5.55 0 0 1 2.64 1.05c-.45.97-1.82.31-2.28 1.28"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#629533",
    d: "M26.958 56.257c2.51-.62 5.07-.13 7.6-.34-.1 1.21.25 2.68-2 1.93-1.16-.39-1.73.68-2 1.76-1 .08-1-.46-.64-1.14-1.46-.83-3.12-.71-4.7-.95-.71-.11-1.76.23-1.63-1 .1-.9 1-.76 1.65-.72a7.7 7.7 0 0 1 1.72.46"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5F9131",
    d: "M29.988 58.467c-.027.47.218.914.63 1.14 2.36.4 4.24 1.87 6.37 2.8.58.26 1.08.91.27 1.59-1.56-.38-3-1.51-4.73-1 0-2.12-1.58-2.59-3-2.09-1.08.39-1.85-.19-2.78 0-.75.13-1.9-.07-1.67-1 .28-1.14 1.19-.4 1.82 0 1.72.88 1.66-1.89 3.09-1.44"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#609232",
    d: "M36.528 60.507a2.64 2.64 0 0 1-2.68-1c1.44-.84 2.53-1.22 2.68 1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#689D36",
    d: "m40.478 64.867-.92-.59c.2-.12.45-.37.57-.32q.483.267.89.64z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#659935",
    d: "M59.248 57.717c-1.36-.07-2.38-1.33-4-.86-.69.21-1.32-.88-1.41-1.82l.35-.23a4.24 4.24 0 0 1 2.12-.09c3.31.29 3.42.37 2.94 3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#619332",
    d: "M59.248 57.717c.56-3.25-2.63-1.61-3.63-2.76.203-.236.482-.395.79-.45 1.1.11 2.1-.63 3.22-.4.476.048.92.264 1.25.61-.41.61-1.45 1.24.08 1.76l-1.12 1.22z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#669A35",
    d: "m52.098 55.117-.66-1.73c1.17 0 2.31-.59 3.5-.16.46 1.1-.42 1.39-1.08 1.81a1.54 1.54 0 0 0-1.76.08"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#629433",
    d: "M50.718 63.377h-.58c.25-1.67.56-3.26 2.84-1.89-.55.9-2.01.66-2.26 1.89"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#669A35",
    d: "M51.058 58.097c-.06.61-.18 1.21-1 1.07-.2 0-.52-.37-.5-.54.11-.83.76-1 1.46-1.12.02.2.04.39.04.59"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#629533",
    d: "m37.988 53.957-4.09.19a22.5 22.5 0 0 1-2.8-2.81c-.43-.69-.89-1-1.54-.2s-1.34 1.09-2.23.38a2.28 2.28 0 0 1 1.29-2c-.76-1-1.88-.64-3.33-1.44a44 44 0 0 1 8.33-.32l.31.24c.415.636.598 1.395.52 2.15-.05 1.66 1.05 1.72 2.27 1.57.37-.62.76-.63 1.17 0a1.6 1.6 0 0 1 .1 2.24"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#639633",
    d: "m29.218 41.517 1.75-.08c.51.78 1.56.62 2.16 1.24q.245.325.42.69c.26.64.82 1.11 1.07 1.73.71 1.83-.06 2.15-1.65 1.52a3.93 3.93 0 0 0-2.35-.48c-.38-.49-.28-1.14-.58-1.66a7 7 0 0 1-.72-1.21z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#609232",
    d: "M32.968 46.617c.66-.18 2.16.09.89-1.25a3 3 0 0 1-1-2.26c.94-.86 1.86-1.79 3.31-1.58.505.255.871.72 1 1.27.1.95-.81 1.26-1.2 1.9a1.56 1.56 0 0 0-.35 1.13c.15 1.5-.54 2.13-2 1.93zM30.518 44.377c1 .55.21 1.17.08 1.76-.54.94-1.08 1.89-1.75.08.45-.71.27-2 1.67-1.84"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#649834",
    d: "M21.218 45.957a1.42 1.42 0 0 1 2.34-.11c-.77.35-1.51 1.16-2.34.11"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5F9031",
    d: "M64.058 60.427h-.59c-.9-.68-2 .2-3-.45-.55-1.93 1.08-.92 1.7-1.25.89.05 1.92-.41 2.52.58.15.2-.39.75-.63 1.12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5E8F31",
    d: "M64.398 55.147c.39-.71 1.09-.62 1.73-.67.26 2.41-.96.93-1.73.67"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#649734",
    d: "m22.788 41.807 1.75-.08c-.31 1.23 2.08 1.06 1.3 2.48-.21.4-.6.92-1.14.59a3.13 3.13 0 0 1-1.91-2.99"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5D8D30",
    d: "m30.518 44.377-1.67 1.84a1.57 1.57 0 0 1-.08-1.76.798.798 0 0 1-.05-1.16h.58a1.062 1.062 0 0 1 1.22 1.08"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#649834",
    d: "M28.718 43.297c0 .39 0 .77.05 1.16-.7-.09-1.66 0-1.33-1.13.18-.61.83-.62 1.28-.03"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#639534",
    d: "M60.518 60.007c1 .1 2.09-.49 3 .45-1.04-.1-2.13.5-3-.45"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#699F37",
    d: "m60.868 54.717-1.17.06a1.27 1.27 0 0 1-.08-1.76v-.58a3.9 3.9 0 0 1 2.36.48c0 .84.71 1 1.52 1.56z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5C8C30",
    d: "M27.328 51.557a1.82 1.82 0 0 0 1.9-1c.29-.65.52-1.69 1.57-1.24.87.37.5 1.35.63 2.07-.12 1.39-.14 2.86-2.23 2.45-.31-1.04-1.86-1.02-1.87-2.28"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#639633",
    d: "M29.198 53.817c1.46-.16 1.14-2 2.23-2.45 1.48.36 2.06 1.51 2.47 2.82-1.76-.18-3.59.75-5.29-.35z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#669A35",
    d: "M48.138 32.447c.57-.24 1.66.89 1.73-.66.45 1.22 3.11 2.22.33 3.77-.86.48-1.62 1.5-2-.37-.15-.77-.66-.87-1.31-.56a3 3 0 0 1-2.79-.24c-.76-.82-1.63-.23-2.46-.23-.61 0-1.65.65-1.69-.75 2.67-1.11 5.54-.06 8.19-.96"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#659A34",
    d: "M37.778 36.437c3.08-.17.06 1.42.76 2.18 2.19-.59 4.57 2.53 6.94-.19 1 0 .93.62.83 1.29-2.49 3.1-5.62 1.46-8.57 1.17l-.36-.33c.52-1.32-1.24-2.16-.74-3.48.2-.52.47-.93 1.14-.64"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5F9131",
    d: "M55.898 35.617c1 .69 1.78-.39 3-.23-1.14 1.56-1.18 4-4 3.2.17-1.04-.86-2.51 1-2.97"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5F9031",
    d: "M46.118 39.577a1.19 1.19 0 0 0-.64-1.15c2.48-.11 4.75-1.48 7.29-1.11.14 0 .21.5.31.77v.58a11.16 11.16 0 0 1-6.96.91"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#659935",
    d: "M36.258 41.777c-1.29.07-2 1.62-3.45 1.33v-.59c-.47-.77.08-1.25.5-1.77 1.31-1.38 2.76.45 4.1-.19.121.1.197.244.21.4v.26c-.38.47-.72.87-1.36.56"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5F9031",
    d: "m30.178 36.787 1.14-.64 1.83 1.67c-.48.47-1 .94-1.72.67-1-.64-1.38 1-2.32.69l-1.16.05c0-.36-.72-1.07.15-1 1.29.17 1.62-.64 2.08-1.44"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#699F37",
    d: "M39.978 33.407c.82.9 1.69.46 2.56.1s1.44-.1 1.59.88l-5.85.27c.03-1.15.4-1.83 1.7-1.25"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#669A35",
    d: "M41.668 36.957c1-1 2.18-.87 3.91-.52a4.69 4.69 0 0 1-3.91.52"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#699E37",
    d: "M33.048 35.477c-.18-1.3 1.11-1.6 1.65-2.41h.58c.388.51.42 1.207.08 1.75a3.83 3.83 0 0 1-2.31.66"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5E8F31",
    d: "M33.278 40.747c-.16.59-.33 1.18-.5 1.77-1.34.87-1.84.33-1.81-1.08z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5B8B2F",
    d: "m37.778 36.437-1.16.64c-.61-.07-1.17-.21-1.09-1 .06-.47.43-.62.82-.68a1.08 1.08 0 0 1 1.43 1.04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31.428 38.487 1.72-.67"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#669B35",
    d: "M56.728 23.527c.21-.18.45-.57.75-.62.6-.1.71.41.81.9s0 .64-.54.59-.94-.11-1.02-.87"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5C8C30",
    d: "M35.858 33.007c-.54-.92-1.84-.14-2.39-1.06 1.31-1.2 2.74 0 4.09-.19.17 1.42-.28 1.99-1.7 1.25"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5B8A2F",
    d: "M46.328 31.357c.468-.066.934.139 1.2.53l-2.47.12c.34-.8.88-.53 1.27-.65"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5E8F31",
    d: "M35.088 28.957c.24 2.48-1.82.72-2.52 1.46.5-1.11 1.79-.76 2.52-1.46"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#629433",
    d: "M37.408 41.137v-.58c2.88-.63 6.06 1.41 8.74-1 2.21-1.23 4.66-.58 7-.91l-.53 1.22c-2.34.88.2 1.55.1 2.34-.33.15-.84.23-1 .49-1.24 2.55-2.35 1.83-3.48-.08a4 4 0 0 0-.83-.76.422.422 0 0 0-.69.12c-.11.17-.05.34.13.49l-1.7 1.25c.131.419.346.807.63 1.14-.08.65.11 2-.88 1.41-1.42-.88-2.51.07-3.74 0a.69.69 0 0 1-.61-.55c.39-.71 1.09-.62 1.73-.67.24-.2.43-.41 0-.58-1.67-2.34-3.14-.39-4.68.21a2.47 2.47 0 0 1-2.36-.48l1.66-1.24c.33-.58 1.1-1 .51-1.82"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5E8F31",
    d: "M59.618 42.817c0 .32-.25.55-.54.36a4 4 0 0 1-.73-.81c.21-.12.42-.35.62-.34.5.01.65.37.65.79"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5C8C30",
    d: "M33.618 47.757c1-.48 1.92-1.05 1.64-2.42a.36.36 0 0 1 .59 0c.41 1 1.57 1.33 2.24 2.17-1.46.29-1.63.83-1.37 4.23-2.72 1.14-3.11.85-2.83-2a9 9 0 0 0-.27-1.98"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5D8D30",
    d: "M50.618 48.737c.64.74 2 1.61-.34 1.77-1 .07-2.06.1-3.09.15-1.14.35-1.59-.37-1.94-1.25 0-.14.07-.29.11-.43 1.756.171 3.527.09 5.26-.24"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#639633",
    d: "m37.988 53.957-.11-2.33h.94a7 7 0 0 0 1.05-.1h.35l1.78.5a1.94 1.94 0 0 1 1.43 1 .6.6 0 0 1-.18.65 4.3 4.3 0 0 1-1.63-.16c-1.45-.93-1.29.06-1.26 1-.82-.08-1.74.31-2.37-.56"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5B8A2F",
    d: "M43.218 53.177a2 2 0 0 1-1.22-1.12c.26-.77-1.53-2 .48-2.36h.48c1.19.43 2 1.17 1.84 2.55-.11.94-.58 1.47-1.58.93"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5C8C30",
    d: "m40.538 45.687.61.55 2.12 1.34c-1.76 0-2.95.19-3.59-1.08-.3-.54.42-.69.86-.81"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#669B35",
    d: "M42.478 49.697c1.83-2.61 1.9-2.63 2.9-.72a2 2 0 0 1-2.9.72"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5C8C30",
    d: "M45.768 44.857c-1 .08-.9-.49-.63-1.14a2.06 2.06 0 0 1 2.39 1.06l-.56.61zM38.468 51.637c0-.57 0-1.28.69-1.39.91-.15.94.68 1.06 1.31a1.29 1.29 0 0 1-1.75.08"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#659934",
    d: "M35.838 45.317h-.59l-.05-1.17a3.95 3.95 0 0 1 2.36.48c-.38.73-1.08.64-1.72.69"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#669A35",
    d: "M42.238 44.437c.43-.13.85-.27 1.29-.37 0 0 .21.32.17.42-.28.67-.92.43-1.43.53z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#609232",
    d: "m42.478 49.697 2.9-.72a3.65 3.65 0 0 0 1.83 1.68l.69 2.3c-1.58.1-3 1-4.65.79v-.58c3.01-1.85-.57-2.3-.77-3.47"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#699E38",
    d: "m53.858 55.037 1.08-1.81 1.17-.05v.58a.79.79 0 0 1 0 1.17l-.49.03a1.54 1.54 0 0 1-1.76.08"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#59882E",
    d: "m49.718 50.837.8.8c-.16.15-.36.46-.49.43a.83.83 0 0 1-.56-.47c-.06-.18.15-.44.25-.76"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#649734",
    d: "M52.678 42.207c.78.11 1.83-.5 2.22.69.18.54-.27.87-.8.94-1.27.16-1.37-.72-1.42-1.63"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5B892F",
    d: "M46.838 42.467c-.55-.39-.89-1-.27-1.39s.72.32.83.78z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#659934",
    d: "M56.188 54.957v-1.17c1.38.79 2.17-1.18 3.48-.74l.08 1.76z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#629533",
    d: "m48.328 62.317-.61-.56c-.27-1.86 1-1.84 2.26-1.86z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#689D37",
    d: "M37.408 41.137c.59.08 1.59-.29 1.5.7s-1.16 1-2 1.09a1.25 1.25 0 0 1-.64-1.15z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#689D36",
    d: "M50.458 40.327a1 1 0 0 1-1.08.76.79.79 0 1 1 .09-1.57.9.9 0 0 1 .99.81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38.468 51.637 1.75-.08"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "m38.458 32.197-.05 5.16 8.78.08-14.89 12.99 6.2 3.34 13.46-11.65-.07 8.86 5.08.04.16-18.67z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "menu_mausseite_svg__a",
    width: 93.426,
    height: 90.452,
    x: 0,
    y: 0,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    xmlns: "http://www.w3.org/2000/svg",
    in: "SourceGraphic",
    stdDeviation: 1.717
  }), /*#__PURE__*/React.createElement("feOffset", {
    xmlns: "http://www.w3.org/2000/svg",
    dx: 2,
    dy: 2,
    result: "pf_100_offsetBlur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    xmlns: "http://www.w3.org/2000/svg",
    floodColor: "#000",
    floodOpacity: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    xmlns: "http://www.w3.org/2000/svg",
    in2: "pf_100_offsetBlur",
    operator: "in",
    result: "pf_100_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    xmlns: "http://www.w3.org/2000/svg",
    in: "SourceGraphic",
    in2: "pf_100_dropShadow"
  })))));
};
export default SvgMenuMausseite;